import { memo } from "react";
import { generatePath, Navigate } from "react-router";

import { PATHS } from "@/routes/paths";

import { DiscountOrdinaryNewPagePresenter } from "./presenter";
import * as DiscountItemOrdinaryShared from "../../_shared";

type Props = {
	hotelID: string;
	duplicateDiscountID?: string;
};

export const DiscountOrdinaryNewPageContainer = memo(({ hotelID, duplicateDiscountID }: Props) => {
	const { discountOrdinaryNewItemForOrdinaryServerModel } =
		DiscountItemOrdinaryShared.Model.Repository.Query.useDiscountOrdinaryNewItemForOrdinaryQuery(
			hotelID,
			duplicateDiscountID,
		);

	if (!discountOrdinaryNewItemForOrdinaryServerModel) {
		return <Navigate to={generatePath(PATHS.HOTEL.ITEMS.DISCOUNT.TOP, { hotelID })} />;
	}

	return (
		<DiscountOrdinaryNewPagePresenter
			hotelID={hotelID}
			discountOrdinaryNewItemForOrdinaryServerModel={discountOrdinaryNewItemForOrdinaryServerModel}
		/>
	);
});

DiscountOrdinaryNewPageContainer.displayName = "DiscountOrdinaryNewPageContainer";
